import { render, staticRenderFns } from "./ShouninInputForm.vue?vue&type=template&id=36fe17e4&scoped=true&"
import script from "./ShouninInputForm.vue?vue&type=script&lang=ts&"
export * from "./ShouninInputForm.vue?vue&type=script&lang=ts&"
import style0 from "./ShouninInputForm.vue?vue&type=style&index=0&id=36fe17e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fe17e4",
  null
  
)

export default component.exports